mutation UpdatePeepMap($input: PeepMapUpdateInput!) {
    peepMapUpdate(input: $input) {
        contact {
            id
        }
        account {
            id
        }
    }
}
